import { BUSINESS_ERROR_CODE } from '../../enums';

export const LENS_ERROR_MAP = {
  LOTRHKR07J0001E: BUSINESS_ERROR_CODE.L0013,
  LOTRHKR07J0002E: BUSINESS_ERROR_CODE.L0020,
} as const;
export type LensErrorCode = keyof typeof LENS_ERROR_MAP;
